import { render, staticRenderFns } from "./DaumAddress.vue?vue&type=template&id=c673a920&scoped=true&"
import script from "./DaumAddress.vue?vue&type=script&lang=js&"
export * from "./DaumAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c673a920",
  null
  
)

export default component.exports